import { Box, Button, Container, Menu, MenuItem } from '@mui/material'
import { Product } from './product/Index'
import { MyBank } from './mybank/Index'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Training } from './training/Index'
import { useContext, useState } from 'react'
import { ToolContext } from '../../../core/context/ToolContext'
import { Contact } from './contact/Index'
import { Membership } from './offerings/membership/Index'

export const Setup = ({match}) => {
    const { setup_state, tool_state } = useContext(ToolContext)
    const { anchorOffer } = setup_state
    const offerings_open = Boolean(anchorOffer.data)
    const [activeOffering, setActiveOffering] = useState(match.params.sub === 'training' || match.params.sub === 'membership' ? match.params.sub : null);

    const urlSub = match.params.sub
    const history = useHistory()

    const handlerbBtnType = (val) => {
        setActiveOffering(val)
        history.push(`${val}`)
        anchorOffer.set(null)
    }
    const handleTopBtn = (e, type) => {
        if (type === 'offerings') {
            anchorOffer.set(e.currentTarget)
        }else if (type === 'contact') {
            history.push(`${type}?subft=product`)
        }else{
            history.push(type)
        }
    }

    const handleClose = () => {
        anchorOffer.set(null)
    }

    const isActive = (key) => urlSub === key;

    const btnStyle = (key) => ({
        width: '120px',
        fontWeight: isActive(key) ? 600: 400,
        textTransform: 'none',
        bgcolor: isActive(key) ? '#11783C' : '#f0f0f0',
        color: isActive(key) ? '#fff' : '#333',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            bgcolor: isActive(key) ? '#0e5f2f' : '#e0e0e0'
        }
    })
    
    return (
        <Container sx={{height: '100%', display: 'flex', flexDirection: 'column', p: '30px !important'}} maxWidth="xl">
            {/* <Box display="flex" gap="16px">
                <Button sx={{fontSize: 20, fontWeight: 700 }} onClick={(e) => handleTopBtn(e, 'contact')}>Contacts</Button>
                
               
                <Button sx={{fontSize: 20, fontWeight: 700 }} onClick={(e) => handleTopBtn(e, 'mybank')}>Banks</Button>
            </Box> */}
            <Box display="flex" gap="16px" flexWrap="wrap">
                <Button variant="contained" sx={btnStyle('contact')} onClick={(e) => handleTopBtn(e, 'contact')}>
                    Contacts
                </Button>
                <Button variant="contained" sx={btnStyle(activeOffering)} onClick={(e) => handleTopBtn(e, 'offerings')}>Offerings</Button>
                 <Menu open={offerings_open} anchorEl={anchorOffer.data} 
                    onClose={handleClose}
            >
                    {/* <MenuItem>Product</MenuItem>
                    <MenuItem>Real Properties</MenuItem> */}
                    <MenuItem sx={{fontSize: 14}} onClick={() => handlerbBtnType('training')}>Training</MenuItem>
					<MenuItem sx={{fontSize: 14}} onClick={() => handlerbBtnType('membership')}>Membership</MenuItem>
                    {/* <MenuItem>Booking Amenities</MenuItem> */}
                </Menu>
                <Button variant="contained" sx={btnStyle('mybank')} onClick={(e) => handleTopBtn(e, 'mybank')}>
                    Banks
                </Button>
            </Box>
            {
                urlSub === 'contact' ? (
                    <Contact tool_state={tool_state} />
                ) : urlSub === 'product' ? (
                    <Product />
                ) : urlSub === 'mybank' ? (
                    <MyBank />
                ) : urlSub === 'training' ? (
                    <Training setup_state={setup_state} tool_state={tool_state} />
                ) : urlSub === 'membership' ? (
                    <Membership/>
                ) : (
                    <Box display="flex">
                        Error 404
                    </Box>
                )
            }
          
        </Container>
        // <Box height="100%" width="100%" display="flex" flexDirection="column" p={2} bgcolor="#f0f5f9">
        //     <Box display="flex" alignItems="center" gap="16px">
        //         <Box component={Button} onClick={() => handlerbBtnType('mybank')}>
        //             My Bank
        //         </Box>
        //     </Box>
        //     <Box display="flex" alignItems="center" gap="16px">
        //         <Box component={Button} onClick={() => handlerbBtnType('shipping')}>
        //             Shipping Fee
        //         </Box>
        //         <Box component={Button} onClick={() => handlerbBtnType('product')}>
        //             Product
        //         </Box>
        //         <Box component={Button} onClick={() => handlerbBtnType('mybank')}>
        //             My Bank
        //         </Box>
        //     </Box>
        //     {
        //         urlSub === 'shipping' ? (
        //             <Shipping />
        //         ): urlSub === 'product' ? (
        //             <Product />
        //         ): urlSub === 'mybank' ? (
        //             <MyBank />
        //         ):(
        //             <Box display="flex">
        //                 Error 404
        //             </Box>
        //         )
        //     }
        //     <Training />
        // </Box>
        // KHARL CHANGES
        // <Box component={Button} onClick={() => handlerbBtnType('product')}>
        //                 Product
        //             </Box>
        //             <Box component={Button} onClick={() => handlerbBtnType('mybank')}>
        //                 My Bank
        //             </Box>
        //         </Box>
        //         {
        //             urlSub === 'shipping' ? <Shipping /> : 
        //             urlSub === 'product' ? <Product /> : 
        //             urlSub === 'mybank' ? <MyBank /> :
        //             <Box display="flex"> Error 404 </Box>
        //         }
    )
}
